import Udesk from 'Udesk';
import SdkLoaderBase from 'Component/common/sdk-loader-base';
import UdeskLocales from 'UdeskLocales';

class AgentReportComponent extends SdkLoaderBase {
    privates = {
        renderContainerId: 'customer-service-score',
        pageTitle: /* 质检总览报表 */UdeskLocales['current'].pages.dataAnalysis.qualityInspectionOverview.index.qualityInspectionOverviewReport,
    };
}

export default Udesk.react.udeskify(AgentReportComponent);
